import { render, staticRenderFns } from "./DeliverableContact.vue?vue&type=template&id=0c41b264&"
import script from "./DeliverableContact.vue?vue&type=script&lang=js&"
export * from "./DeliverableContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c41b264')) {
      api.createRecord('0c41b264', component.options)
    } else {
      api.reload('0c41b264', component.options)
    }
    module.hot.accept("./DeliverableContact.vue?vue&type=template&id=0c41b264&", function () {
      api.rerender('0c41b264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/DeliverableContact.vue"
export default component.exports